import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    padding: 14,
    width: '100%'
  },
  strategyIcon: {
    flex: '0 0 56px',
    borderRadius: '50%',
    verticalAlign: 'middle',
    overflow: 'hidden',
    marginRight: 14,
    width: 56,
    height: 56,
    '& img': {
      width: '100%',
    }
  },
  strategyDescription: {
    width: 'auto',
    flex: '0 1 auto',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    minWidth: 0,
    padding: 0,
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      padding: '0 8px 0 0',
    },
  },
  nameSection: {
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  descriptionTitle: {
    color: theme.palette.primary.main,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  descriptionCaption: {
    color: theme.palette.grey.color
  },
  copying: {
    color: theme.palette.green.color,
    fontWeight: 400,
  },
  controls: {
    margin: '10px auto',
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      margin: '10px 0',
    },
  },
  hidePerformanceNotice: {
    margin: '10px 0',
    padding: '0 8px',
    [theme.breakpoints.up('md')]: {
      margin: 0,
    },
  },
}))
